

/** @type {import('./type')} */
module.exports = TypeError;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-errors/type.js
// module id = ../node_modules/es-errors/type.js
// module chunks = 0